import Modal, { ModalSize } from "~/common/components/Modal";
import PageToolbar from "~/common/components/PageToolbar";
import { Button, Stack } from "~/common/mui";
import { fetchContractsOverview } from "~/features/contracts/api/getContractsOverview";
import { navigateToProductContract } from "~/features/contracts/utils/utils";
import { useState } from "react";
import {
  decideLoadedStep,
  useAddToCartWizardContext,
} from "~/features/addToCart/components/AddToCartProcess/AddToCartWizard";
import { Alert } from "~/common/mui/Alert/Alert";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import classNames from "classnames";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ContractAvailableModal = ({ productDescriptor }: Props) => {
  const { t, getModalProps, setStep, closePopup, getCloseBtn } = useAddToCartWizardContext();

  const isTablet = useIsMinTabletSize();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const modalProps = getModalProps();
  return (
    <Modal
      {...modalProps}
      size={ModalSize.MEDIUM}
      onClose={() => closePopup()}
      noPadding={true}
      footerClassName={classNames(!isTablet && "scha__add-to-cart-popup-footer")}
      footerChildren={
        <PageToolbar
          className={"w-100"}
          noBottomSpace={true}
          left={isTablet && getCloseBtn(t("close"), false)}
          right={
            <Stack direction="row" gap={1} className={classNames(!isTablet && "w-100 scha__ellipsis-text")}>
              <Button
                className={classNames(!isTablet && "w-100")}
                color={"secondary"}
                onClick={() => setStep(decideLoadedStep(productDescriptor))}
                clta-modal-child-marker="without-contract"
              >
                {t("popup.atc.btn.withoutContract")}
              </Button>
              <Button
                className={classNames(!isTablet && "w-100")}
                onClick={() => {
                  setLoading(true);
                  fetchContractsOverview()
                    .then((data) => navigateToProductContract(data, productDescriptor.base.designation))
                    .catch(() => {
                      setLoading(false);
                      setError(true);
                    });
                }}
                loading={loading}
                clta-modal-child-marker="with-contract"
              >
                {t("popup.atc.btn.fromContract")}
              </Button>
            </Stack>
          }
        />
      }
      rootProps={{
        "clta-modal-parent-marker": "true",
        "clta-product-name": productDescriptor.base.designation,
        "clta-product-id": productDescriptor.base.sapMaterialNumber,
      }}
    >
      <div className={"scha__add-to-cart-popup__contract-question"}>
        {!error && <Alert severity={"info"}>{t("popup.atc.contractInfo")}</Alert>}
        {error && <Alert severity={"error"}>{t("popup.atc.contractError")}</Alert>}
      </div>
    </Modal>
  );
};
